import {Pipe, PipeTransform} from '@angular/core';
import {OuvragesUtils} from 'app/shared/utils/ouvrages.utils';

/**
 * Renvoie la lettre à afficher pour une qualification.
 */
@Pipe({name: 'paramQualifLetter'})
export class ParamQualifLetterPipe implements PipeTransform {

    constructor() {
    }

    transform(qualif: string): string {
        return OuvragesUtils.getParametreQualifLetter(qualif);
    }
}
